import U14Api from './u14-api';


export default (di) => {
	di
		.setType({type: U14Api, name: 'U14Api', parent: 'Api', mixins: ['responsePayloadMixin']})
		.set('api/api', di.lazyNew('U14Api'))
	;
};
